import React from 'react'

function ColorPicker() {
  return (
    <div>ColorPicker</div>
  )
}

export default ColorPicker